import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSurfingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.86 1.14a1.448 1.448 0 00-.57-.328 2.988 2.988 0 00-.721-.135c-.545-.04-1.238.025-2.057.265-1.638.482-3.799 1.676-6.337 4.214-3.803 3.803-4.68 6.75-4.81 7.267a.759.759 0 00.202.724l2.286 2.286c.17.17.438.273.723.2.365-.091 1.933-.553 4.157-2.145.926 1.35 2.917 1.547 4.082.294l.073-.078c.966 1.166 2.804 1.286 3.903.104l-.915-.85c-.653.701-1.81.518-2.214-.351l-.095-.204a.625.625 0 00-1.025-.163l-.642.69c-.624.672-1.7.549-2.17-.201a26.507 26.507 0 002.689-2.498l.094.204c.697 1.499 2.54 1.945 3.834 1.08l.52-.348-.695-1.039-.52.348a1.377 1.377 0 01-2.005-.568l-.323-.695c1.546-1.848 2.357-3.446 2.733-4.726.24-.818.305-1.512.265-2.057a2.994 2.994 0 00-.135-.722 1.45 1.45 0 00-.328-.568zM6.117 6.1c2.423-2.424 4.397-3.475 5.77-3.879.688-.202 1.22-.24 1.584-.214a1.676 1.676 0 01.436.084l.014.039c.028.084.057.215.07.398.027.363-.012.895-.214 1.583-.404 1.373-1.455 3.347-3.878 5.77-3.065 3.065-5.49 4.082-6.345 4.368l-.46-.46 8.617-8.618-.884-.884-8.617 8.618-.461-.461c.286-.855 1.303-3.28 4.368-6.345z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSurfingNormalXsmall;
